export default __webpack_public_path__ + "static/media/img11.2c5388e5.jpeg";